import { withRouter } from 'react-router-dom';
import SubNavBar from './SubNavBar';
import SubNavBarContainer from './SubNavBar.container';

export default withRouter(SubNavBarContainer(SubNavBar));
